import {Fragment, useEffect, useState} from 'react';
import classNames from 'classnames';
import {Route, Routes} from 'react-router-dom';

import {AccountService} from '../service/AccountService';
import {TenantSettingService} from './he-thong/tham-so-he-thong/TenantSettingService';

import {AppTopbar} from './AppTopbar';
import {AppBreadCrumb} from './AppBreadCrumb';

import Dashboard from './components/Dashboard';
import Admin from './admin';
import Category from './danh-muc';
import System from './he-thong';
import Invoice from './hoa-don';
import Publish from './phat-hanh';
import LichSuTruyenNhan from './lich-su-truyen-nhan';
import XuLySaiSot from './xu-ly-sai-sot';
import BaoCao from './bao-cao';
import { BangTongHop } from './bang-tong-hop';

import {AppStorage} from '../service/UserStorage';
import {FormatDisplay} from '../shared/format';
import Config from './cau-hinh';
import { ApplicationConfigurationService } from '../service/ApplicationConfigurationService';

export default function App() {

  const [layoutColorMode, setLayoutColorMode] = useState('light');

  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (!AppStorage.get('tenant')) {
      window.location.hash = '/login';
    } else {
      const init = [
        TenantSettingService.getList({key: TenantSettingService.key.DINH_DANG_TIEN_TE}).then(({items}) => {
          if (items.length) {
            try {
              const separator = items[0].description.split('VND l� [')[1].substring(0, 1);
              switch (separator) {
                case '.':
                  FormatDisplay.locales = 'vi-VN';
                  break;
                case ',':
                  FormatDisplay.locales = 'en-US';
                  break;
              }
            } catch (e) {
              console.log('DINH_DANG_TIEN_TE khong hop le');
            }
          }
        }),
        FormatDisplay.loadCurrencies()
      ];
      Promise.all(init).then(() => {
        AccountService.getMyProfile().then((user) => {
          if (user?.userName) {
            setUser(user);
            ApplicationConfigurationService.get().then((res) => {
              let permissions = Object.keys(res.auth.grantedPolicies);
              setPermissions(permissions);
              AppStorage.set('pk', JSON.stringify(permissions));
            });
          } else {
            window.location.hash = '/login';
          }
        }).catch(() => {
          window.location.hash = '/login';
        });
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onColorModeChange = (mode) => {
    setLayoutColorMode(mode)
  }

  const wrapperClass = classNames('layout-wrapper layout-overlay', {
    'layout-theme-light': layoutColorMode === 'light'
  });

  return (
    <div className={wrapperClass}>
      {user &&
				<Fragment>
					<AppTopbar layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} user={user} permissions={permissions}/>
					<AppBreadCrumb/>

					<div className="layout-main-container">
						<div className="layout-main">
							<Routes>
								<Route path="/" element={<Dashboard/>}/>
								<Route path="admin/*" element={<Admin/>}/>
								<Route path="danh-muc/*" element={<Category/>}/>
								<Route path="he-thong/*" element={<System/>}/>
								<Route path="hoa-don/*" element={<Invoice/>}/>
								<Route path="phat-hanh/*" element={<Publish/>}/>
								<Route path="lich-su-truyen-nhan/*" element={<LichSuTruyenNhan/>}/>
								<Route path="xu-ly-sai-sot/*" element={<XuLySaiSot/>}/>
								<Route path="bao-cao/*" element={<BaoCao/>}/>
                <Route path="cau-hinh/*" element={<Config/>}/>
                <Route path="bang-tong-hop/*" element={<BangTongHop/>}/>
							</Routes>
						</div>
					</div>
				</Fragment>
      }
    </div>
  );
}
